import { Tab, Tabs } from '@blueprintjs/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import CreateLectureModal from '../../components/CreateLectureModal'
import LectureItem from '../../components/LectureItem'
import tabsStyles from '../../components/Tabs/tabs.scss'
import BasicLayout from '../../layouts/BasicLayout'
import { RootState, select, store } from '../../store'
import styles from './my-lecture-page.scss'

const cx = classnames.bind({ ...tabsStyles, ...styles })
// TODO: add tab-content style into it

interface IProps extends Partial<ReturnType<typeof mapState>> {

}

class MyLecturePage extends React.Component<IProps> {
  public state = {
    showModal: false,
    tab: 'paid',
  }
  public handleTabChange = (tab: string) => {
    this.setState({ tab })
  }
  public onCreateLectureToggle = () => {
    this.setState({ showModal: !this.state.showModal })
  }
  public render() {
    const currentUser = firebase.auth().currentUser
    return (
      <BasicLayout className={cx('lecture-page')}>
        <CreateLectureModal isOpen={this.state.showModal} onClose={this.onCreateLectureToggle} />

        <div className={cx('page-title-container--v1')}>
          <div className={cx('container')}>
            <h3 className={cx('page-title')}>
              <span>我的講座</span>
              {
                R.test(/@qraft\.app/)(currentUser ? String(currentUser.email) : '') ?
                  <span onClick={this.onCreateLectureToggle} className={cx('btn', 'btn--xs', 'btn--primary', 'create-btn')}>建立講座</span>
                : null
              }
            </h3>
          </div>
        </div>
        <div className={cx('lecture-tabs')}>
          <div className={cx('container')}>
            <Tabs className={cx('tabs')} onChange={this.handleTabChange} selectedTabId={this.state.tab}>
              <Tab 
                panel={this.renderPaidLectures()}
                id="paid"
                title={(
                  <a className={cx('tabs__link')}>參與講座</a>
                )}
                className={cx('tabs__item')}
                 />
              <Tab
                panel={this.renderCreatedLectures()}
                id="created"
                title={(
                  <a className={cx('tabs__link')}>開設講座</a>
                )}
                className={cx('tabs__item')}
                 />
            </Tabs>
          </div>
        </div>
      </BasicLayout >
    )
  }
  public renderCreatedLectures = () => {
    const { createdLectureIds } = this.props
    return (
            <div className={cx('row')}>
              {
                createdLectureIds ? createdLectureIds.map(lectureId => (
                  <div key={lectureId} className={cx('col-lg-4')}>
                    <LectureItem lectureId={lectureId} />
                  </div>
                )) : '載入中'
              }
            </div>
    )
  }
  public renderPaidLectures = () => {
    const { paidLectureIds } = this.props
    return (
            <div className={cx('row')}>
              {
                paidLectureIds ? paidLectureIds.map(lectureId => (
                  <div key={lectureId} className={cx('col-lg-4')}>
                    <LectureItem lectureId={lectureId} />
                  </div>
                )) : '載入中'
              }
            </div>
    )
  }
}

const mapState = ({ lectures, orders }: RootState) => {
  const rootState = store.getState()
  return {
    lectures, orders,
    createdLectureIds: select.lectures.getCreatedLectureIds(rootState),
    paidLectureIds: select.orders.getPaidOrders(rootState).map(order => order.lectureId),
  }
}
export default connect(mapState)(MyLecturePage)



// WEBPACK FOOTER //
// ./src/pages/MyLecturePage/index.tsx